import AsideMetadata from './asideMetadata';
export default AsideMetadata;
